import { SubmissionError } from 'redux-form';
import { path } from 'ramda';
import { underscoreToCamelNested } from 'helpers/transformations';
import { isValidationReject } from './ajax';

export const prepareErrorsObject = (serverErrors, fieldsLabels = {}) => {
  if (!serverErrors) {
    return {};
  }

  const errors = underscoreToCamelNested(serverErrors);

  return Object.keys(errors)
    .reduce((acc, field) => {
      const errorMessage = Array.isArray(errors[field]) && errors[field].length
        ? errors[field][0]
        : errors[field];
      const label = path(field.split('.'), fieldsLabels);
      if (errorMessage) {
        let target = acc;
        let fieldName = field;
        if (fieldName.match('.')) {
          const parts = fieldName.split('.');
          for (let i = 0; i < parts.length - 1; i += 1) {
            const currentField = parts[i];
            if (!target[currentField]) {
              target[currentField] = {};
            }
            target = target[currentField];
          }
          fieldName = parts[parts.length - 1];
        }
        if (Object.keys(target).length <= 0) {
          console.error(errorMessage);
          alert(errorMessage);
        }
        if (!target[fieldName]) {
          target[fieldName] = `${label ? `${label} ` : ''}${errorMessage}`;
        }
      }
      return acc;
    }, {});
};

export const handleRejectedRequest = fieldsLabels => (error) => {
  if (isValidationReject(error)) {
    throw new SubmissionError(prepareErrorsObject(error.response.data.errors, fieldsLabels));
  }
};
